let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5DNSd")).then(() => parcelRequire('74wMe'));